/*
*
* File JS componente Banner ADV
*
*/


// IMPORT SCSS PER LA COMPILAZIONE
//--------------------------------------------------------------------//

import './banner-adv.scss';

//--------------------------------------------------------------------//


// EXPORT COMPONENTE
//--------------------------------------------------------------------//



const bannerAdv = () => {

    //const blockRelated = document.querySelector('.wrapper-related');
    //const newsLoop = document.querySelector('#news-related-loop');
    //if(!newsLoop) return;

    const {  post_type, post_id } = immediaPostData;
    //let apiRelatedContent = `/wp-json/latest/v1/${post_type}?la=${language}&post_id=${post_id}`;
    let apiBannerContent = `/wp-json/banners/v1/banner`;



    const boxes = document.querySelectorAll(".async-banner");
    let id;
    let position;
    let offset;
    let limit;
    let name;
    let data_term_id;
    let data_post_id;
    let body_to_send = {};
    let temp_obj = {};
    let array = {};
    let obj;

    boxes.forEach(box => {
        id = box.getAttribute("id");
        position = box.getAttribute("data-position");
        offset = box.getAttribute("data-offset");
        limit = box.getAttribute("data-limit");
        name =  box.getAttribute("data-name");
        data_term_id =  box.getAttribute("data-term-id");
        data_post_id =  box.getAttribute("data-post-id");
        if(!array[name])
            array[name] = [];
        temp_obj = {"id":id,"position":position,"offset":offset,"limit":limit,"term_id":data_term_id,"post_id":data_post_id};
        array[name].push(temp_obj);
    });


    /*
    let obj = {
        "positions":
                {
                    "manchette" :
                            [
                                {"id":"manchette-left","position":"manchette-sx","offset":"0","limit":"1"},
                                {"id":"manchette-right","position":"manchette-dx","offset":"0","limit":"1"}

                            ]
                    ,
                    "strip-5-col" :
                            [
                                {"id":"strip-5-col-1","position":"generica","offset":"0","limit":"5"},
                                {"id":"strip-5-col-2","position":"generica","offset":"5","limit":"5"},
                                {"id":"strip-5-col-3","position":"generica","offset":"10","limit":"5"},
                                {"id":"strip-5-col-4","position":"generica","offset":"14","limit":"5"}
                            ]
                    ,
                    "strip-1-col" :
                            [
                                {"id":"strip-1-col","position":"top","offset":"0","limit":"1"},
                            ]
                    ,
                    "strip-2-col" :
                            [
                                {"id":"strip-2-col","position":"top-2","offset":"0","limit":"1"},
                            ],
                    "block-tag-banners" :
                            [
                                {"id":"block-tag-banners","position":"generica","offset":"15","limit":"4"},
                            ]

                },
        "post_id": post_id

    }
     */
    body_to_send.positions = array;
    body_to_send.post_id = post_id;
    obj = body_to_send;

    // FETCH GET RELATED CONTENT
    const getBanners = () => {
        fetch(apiBannerContent, {
            cache: "no-cache",
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(obj),
        })
        .then(response => {
            if (response.ok) {
                return response.json();
            }
            throw new Error('Network response was not ok.');
        })
        .then(({data, status}) => {
            let html_id;
            let content_html;
            if(status == 'OK'){
                if(data.banners){
                    for (let i = 0; i < data.banners.length; i++) {
                        //console.log(data.banners[i].html_content);
                        if(data.banners[i].html_id  !== undefined){
                            html_id = data.banners[i].html_id;
                            content_html =  data.banners[i].html_content;
                            var myEle = document.getElementById(html_id);
                            if(myEle) {
                                //console.log(document.getElementById(html_id));
                                myEle.innerHTML = content_html;
                            }else{
                                console.log('Banner '+html_id+' non trovato nel DOM');
                            }
                        }
                    }
                }
            }
        })
        .catch(error => {
            console.error('Fetch error:', error);
        });
    }
    window.onload = async () => {
        getBanners();
    };

}

export default bannerAdv;





//--------------------------------------------------------------------//